export const colors = [
  '#2c7be5',
  '#00d97e',
  '#e63757',
  '#39afd1',
  '#fd7e14',
  '#02a8b5',
  '#727cf5',
  '#6b5eae',
  '#ff679b',
  '#f6c343',
]

export const chartColors = {
  neutral: '#DFEAFC', // grey
  low: '#98C2F9', // light blue
  medium: '#3278C3', // blue
  high: '#204F89', // dark blue
  good: '#5CBB92', // green
  lessGood: '#F8C60E', // yellow
  bad: '#E25D69', // red
  primary: '#6B76A6', // muted blue
  grey: '#d2d2d2',
}

export const themeColors = {
  primary: '#2c7be5', // light blue
  secondary: '#748194', // dark grey
  success: '#39926B', // bright green
  info: '#27bcfd', // light blue
  warning: '#F3D781', // orange
  danger: '#EF606C', // red
  light: '#f6f6f6', // light grey
  dark: '#242d3a', // black
}

const hexToRgb = (hexValue:String) => {
  const hex = (hexValue.indexOf('#') === 0 ? hexValue.substring(1) : hexValue)
  // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
  const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(
    hex.replace(shorthandRegex, (m, r, g, b) => r + r + g + g + b + b),
  )
  return result ? [parseInt(result[1], 16), parseInt(result[2], 16), parseInt(result[3], 16)] : null
}

export const rgbaColor = (color = colors[0], alpha = 0.5) => `rgba(${hexToRgb(color)},${alpha})`

export const rgbaColors = colors.map((color) => rgbaColor(color))
